module.exports = __webpack_public_path__ + "img/qr-code-wechat.9e11eb6.png";